import React from 'react';
import { NavLink } from 'react-router-dom';
import $ from "jquery";
import 'bootstrap/dist/js/bootstrap';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";

class Header extends React.Component{

    constructor(props){
        super(props);
        this.state={
            navOpen: true,
            dark: false
        }
    }

    handleLogout(){
        localStorage.removeItem('admintoken');
        window.location.reload();
    }

    handleClick(){
        if (this.state.navOpen){
            this.setState({
                navOpen: false
            });
            $('#main').removeClass('col-md-10');
            $('#sidebar').collapse('hide');
        }else {
            this.setState({
                navOpen: true
            });
            $('#main').addClass('col-md-10');
            $('#sidebar').collapse('show');
        }
    }

    handleChange(){
        this.setState({
            dark : !this.state.dark
        },()=>{

        })

    }

    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
    }

    resize() {
        if (window.innerWidth <= 768){
            this.setState({
                navOpen: false
            });
            $('#main').removeClass('col-md-10');
            $('#sidebar').collapse('hide');
        }else {
            this.setState({
                navOpen: true
            });
            $('#main').addClass('col-md-10');
            $('#sidebar').collapse('show');
        }
    }

    render() {
        return(
            <nav id="header" className="navbar navbar-expand-md navbar-light p-0 sticky-top bg-white shadow">
                <div className="d-flex align-items-center">
                    <NavLink id="header_title" to="#" className="navbar-brand bg-light px-3 py-3 px-md-5 m-0 h5">پنل مدیریت</NavLink>
                    <span onClick={this.handleClick.bind(this)} className="oi oi-menu mr-4" />
                </div>
                <div className="collapse navbar-collapse">

                </div>
                <NavLink to="/" className="btn btn-sm btn-primary my-auto mr-auto mx-1">صفحه اصلی</NavLink>

                <button onClick={this.handleLogout.bind(this)} id="logout" className="btn btn-sm btn-danger my-auto mr-auto ml-3 my-1">خروج</button>
            </nav>
        )
    }
}


export default Header;